import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";

import {
  CARRIER_PROFILE_HEADER_CARDS_VM_SHAPE,
} from "./carrierProfileVmPropTypes";

export default function CarrierProfileHeaderCards({ vm }) {
  const {
    setIsEditingCarrier,
    handleSaveCarrier,
    setCarrierDetails,
    isEditingCarrier,
    isSavingCarrier,
    carrierDetails,
    bondGraphData,
    carrier,
  } = vm;
  return (
    <>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card elevation={3} sx={{ borderRadius: '16px', height: 'fit-content' }}>
              <CardHeader
                title={carrier ? `${carrier} - Carrier Details` : 'Carrier Details'}
                sx={{
                  backgroundColor: '#1976d2',
                  color: 'white',
                  '& .MuiCardHeader-title': { fontSize: '1.5rem', fontWeight: 600 }
                }}
                action={null}
              />
              <CardContent sx={{ padding: 3 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label="Carrier Name"
                      name="name"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.name || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, name: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      label="Processing Email"
                      name="carrier_processing_email"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.carrier_processing_email || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, carrier_processing_email: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      label="Agency Code"
                      name="agency_code"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.agency_code || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, agency_code: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  {isEditingCarrier ? (
                    <>
                      <Button variant="outlined" color="primary" onClick={() => setIsEditingCarrier(false)} sx={{ minWidth: 100 }}>
                        Cancel
                      </Button>
                      <Button variant="contained" color="primary" onClick={handleSaveCarrier} disabled={isSavingCarrier} sx={{ minWidth: 100 }}>
                        {isSavingCarrier ? <CircularProgress size={24} color="inherit" /> : 'Save'}
                      </Button>
                    </>
                  ) : (
                    <Button variant="contained" color="primary" onClick={() => setIsEditingCarrier(true)} sx={{ minWidth: 100 }}>
                      Edit
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card elevation={3} sx={{ borderRadius: '16px', height: 'fit-content' }}>
              <CardHeader
                title="Bond History"
                sx={{
                  backgroundColor: '#1565c0',
                  color: 'white',
                  '& .MuiCardHeader-title': { fontSize: '1.5rem', fontWeight: 600 }
                }}
              />
              <CardContent sx={{ padding: 3, marginBottom: 2 }}>
                {bondGraphData.labels.length === 0 ? (
                  <Typography variant="body2" color="text.secondary">No data</Typography>
                ) : (
                  <Bar
                    data={bondGraphData}
                    options={{
                      responsive: true,
                      plugins: { legend: { display: false }, title: { display: false } },
                      scales: { y: { ticks: { beginAtZero: true, precision: 0 } } }
                    }}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>
    </>
  );
}

CarrierProfileHeaderCards.propTypes = {
  vm: PropTypes.shape(CARRIER_PROFILE_HEADER_CARDS_VM_SHAPE).isRequired,
};
